import { useMemo } from 'react'
import { useStore } from 'react-redux'

// Cache do store vazio para evitar recriação
const EMPTY_STORE_CACHE = {}

/**
 * Hook que sempre chama useStore mas retorna objeto vazio quando não necessário
 * Nota: Sempre chamamos useStore para respeitar as regras dos hooks,
 * mas a otimização real vem de retornar um objeto vazio cached
 * @param needsStore - Booleano indicando se o store deve ser retornado
 * @returns Store do Redux ou objeto vazio cached
 */
export const useOptimizedStore = (needsStore: boolean) => {
  const actualStore = useStore()

  return useMemo(() => {
    return needsStore ? actualStore : EMPTY_STORE_CACHE
  }, [needsStore, actualStore])
}

export default useOptimizedStore
